.page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  width: 60rem;
  max-width: 100%;
  margin: 8rem auto;
  background-color: #181a1e;
  border-radius: var(--border-radius-medium);
  padding: 4rem;
  text-align: center;
}

.container {
  position: relative;
  display: flex;
  flex-direction: row;
  margin: 0 2.4rem 2.4rem 2.4rem;

  svg {
    width: 100%;
  }
}
